import Character from "../mechanics/characters/Character"
import { Enemy } from "../mechanics/enemies/Enemy"
import FightMechanic from "../mechanics/FightMechanic"
import { particles } from "../tempDB"
import { gsap } from "gsap"

export interface IinitFCSelectors {
    characterImgSelector: Element | null
    characterContentBlockSelector: Element | null
    characterTakenDamageSelector: Element | null
    enemiesImgSelector: NodeListOf<Element>
    enemiesContentBlockSelector: NodeListOf<Element>
    enemiesTakenDamageSelector: NodeListOf<Element>
}

export interface IinitFightControllerArgs {
    character: Character
    enemiesArr: Enemy[]
    initSelectors: IinitFCSelectors
    setIsWon: React.Dispatch<React.SetStateAction<boolean>>
    setIsLose: React.Dispatch<React.SetStateAction<boolean>>
    setPlayerHp: React.Dispatch<React.SetStateAction<number>>
    enemiesHp: number[],
    setEnemiesHP: React.Dispatch<React.SetStateAction<number[]>>
    setEnemyArr: React.Dispatch<React.SetStateAction<Enemy[]>>
}

// selectors - character selectors
let characterImgSelector: Element | null = null
let characterContentBlockSelector: Element | null = null
let characterTakenDamageSelector: Element | null = null
// selectors - enemies selectors
let enemiesImgSelector: NodeListOf<Element> | null = null
let enemiesContentBlockSelector: NodeListOf<Element> | null = null
let enemiesTakenDamageSelector: NodeListOf<Element> | null = null
// React.SetStateAction from fightscene
let setIsWon: React.Dispatch<React.SetStateAction<boolean>>
let setIsLose: React.Dispatch<React.SetStateAction<boolean>>
let setPlayerHp: React.Dispatch<React.SetStateAction<number>>
let setEnemiesHP: React.Dispatch<React.SetStateAction<number[]>>
let setEnemyArr: React.Dispatch<React.SetStateAction<Enemy[]>>
// React.State from fightscene
let enemiesHp: number[]
// other
let skillIndex = 0
// fightMechanic
const fightMechanic = FightMechanic.getInstance()
// init fightMechanic
export const initFightController = (args: IinitFightControllerArgs) => {
    // set fight order
    fightMechanic.setCharacter(args.character)
    fightMechanic.setEnemiesArr(args.enemiesArr)
    fightMechanic.setTurnOrder()
    // set selectors
    characterImgSelector = args.initSelectors.characterImgSelector
    characterContentBlockSelector = args.initSelectors.characterContentBlockSelector
    characterTakenDamageSelector = args.initSelectors.characterTakenDamageSelector
    enemiesImgSelector = args.initSelectors.enemiesImgSelector
    enemiesContentBlockSelector = args.initSelectors.enemiesContentBlockSelector
    enemiesTakenDamageSelector = args.initSelectors.enemiesTakenDamageSelector
    // set interactions for view
    setIsWon = args.setIsWon
    setIsLose = args.setIsLose
    setPlayerHp = args.setPlayerHp
    enemiesHp = args.enemiesHp
    setEnemiesHP = args.setEnemiesHP
    setEnemyArr = args.setEnemyArr
}
// setSkillindex 
export const FightControllerSetSkillIndex = (chosenSkillindex: number) => {
    skillIndex = chosenSkillindex
}
// метод нанесения урона 
export const FightControllerDealDamage = (enemyIndex: number) => {
    const fightOrder = fightMechanic.getOrder()
    // create selectors arr
    const selectorsByFightOrder = [characterImgSelector]
    enemiesImgSelector?.forEach(item => selectorsByFightOrder.push(item))
    // current selector by turn
    const currentSelector = selectorsByFightOrder[fightMechanic.getCurrentTurn()]

    fightMechanic.setSkillIndex(skillIndex)
    fightMechanic.setCharacterIndex(enemyIndex)

    if (currentSelector)
        animateTurnAndShowDmg(currentSelector, fightOrder, enemyIndex)
}

const animateTurnAndShowDmg = (currentSelector: Element, fightOrder: Character[], enemyIndex: number) => {
    const mainCharacter = fightMechanic.getCharacter()
    const enemiesArr = fightMechanic.getEnemiesArr()

    const oldCharHp = mainCharacter.getHp()
    // checking npc turn or not 
    if (fightOrder[fightMechanic.getCurrentTurn()].getIsNpc()) {
        // checking npc by current turn alive 
        if (fightOrder[fightMechanic.getCurrentTurn()].getHp() > 0) {
            // if alive do func
            const ctx = gsap.context(() => {
                gsap.timeline()
                    .fromTo(currentSelector, { x: 0, onComplete: () => console.log() }, {
                        x: -400, onComplete: () => {
                            fightMechanic.npcTurn()
                            if (characterContentBlockSelector) showParticles(characterContentBlockSelector)
                            const dmg = oldCharHp - mainCharacter.getHp()
                            if (characterTakenDamageSelector) showTakenDamage(characterTakenDamageSelector, dmg)
                            setPlayerHp(mainCharacter.getHp())
                            if (fightMechanic.getIsLose()) setIsLose(fightMechanic.getIsLose())
                        }
                    })
                    .to(currentSelector, {
                        x: 0, onComplete: () => {
                            if (fightMechanic.getIsLose()) {
                                return
                            } else {
                                fightMechanic.nextTurn()
                            }
                            if (fightOrder[fightMechanic.getCurrentTurn()].getIsNpc() && fightMechanic.getCurrentTurn() !== fightOrder.length) {
                                FightControllerDealDamage(enemyIndex)
                            }
                        }
                    })
            })

            return () => ctx.revert()

        } else {
            // if npc is dead
            fightMechanic.nextTurn()
            if (fightOrder[fightMechanic.getCurrentTurn()].getIsNpc() && fightMechanic.getCurrentTurn() !== fightOrder.length) {
                FightControllerDealDamage(enemyIndex)
            }
        }

    } else {
        // mainCharacter turn
        const ctx = gsap.context(() => {
            gsap.timeline()
                .fromTo(currentSelector, { x: 0, onComplete: () => { } }, {
                    x: 400, onComplete: () => {
                        if (enemiesContentBlockSelector) showParticles(enemiesContentBlockSelector[enemyIndex])
                        fightMechanic.doSkill()
                        const dmg = enemiesHp[enemyIndex] - enemiesArr[enemyIndex].getHp()
                        if (enemiesTakenDamageSelector) showTakenDamage(enemiesTakenDamageSelector[enemyIndex], dmg)
                        enemiesHp[enemyIndex] = enemiesHp[enemyIndex] - dmg
                        setEnemiesHP(enemiesHp)
                        setEnemyArr([...enemiesArr])
                        if (fightMechanic.getIsWon())  
                            setIsWon(fightMechanic.getIsWon())
                    }
                })
                .to(currentSelector, {
                    x: 0, onComplete: () => {
                        if (fightMechanic.getIsWon()) {
                            return
                        } else {
                            fightMechanic.nextTurn()
                        }
                        FightControllerDealDamage(enemyIndex)
                    }
                })
        })

        return () => ctx.revert()
    }
}

const showParticles = (element: Element) => {
    const arrOfparticleImg: HTMLImageElement[] = []

    for (let i = 0; i < particles.length; i++) {
        let newElement = document.createElement('img')

        newElement.src = particles[i]
        newElement.alt = ''
        arrOfparticleImg.unshift(newElement)
    }

    arrOfparticleImg.forEach(item => element.appendChild(item))

    const killParticles = () => {
        arrOfparticleImg.forEach((particle) => {
            element.removeChild(particle);
        });
    }

    gsap.set(arrOfparticleImg, {
        position: 'absolute',
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        opacity: 1
    });

    gsap.to(arrOfparticleImg, {
        onComplete: killParticles,
        keyframes: [
            {
                ease: "expo.out",
                duration: 1,
                stagger: {
                    amount: 0.1
                }
            },
            { opacity: 0, delay: -3 }
        ]
    })
}

const showTakenDamage = (element: Element, dmg: number) => {
    (dmg) ? element.innerHTML = `${dmg}` : element.innerHTML = 'Miss'

    const tdctx = gsap.context(() => {
        gsap.set(element, {
            opacity: 1,
            transform: 10
        })

        gsap.to(element, { opacity: 0, transform: 0 })
    })

    return () => tdctx.revert()
}

export function resetFightMechanic() {
    fightMechanic.reset()
}